import React, { useState } from "react";
import "./speakerV2.css";

const getSpeakerName = (s) => s?.name || s?.full_name || s?.speaker_name || "—";

const getAvatarInitials = (name = "") => {
  const words = name.toString().trim().split(/\s+/);
  const initials = [];
  const mainWords = words.filter(w => !/^(prof|dr|mr|ms|mrs)\.?$/i.test(w));
  if (mainWords.length >= 1) initials.push(mainWords[0][0]?.toUpperCase() || "");
  if (mainWords.length >= 2) initials.push(mainWords[1][0]?.toUpperCase() || "");
  return initials.join("") || "S";
};

const SingleSpeakerV2 = ({ speaker, countryName, flagUrl }) => {
  const [showBioModal, setShowBioModal] = useState(false);
  const name = getSpeakerName(speaker);
  const initials = getAvatarInitials(name);

  const biography = speaker.biography || ``;
  const shortBio = biography.length > 60 ? biography.substring(0, 60) + "..." : biography;

  return (
    <div className="spCard">
      {/* 1. Main Card Header */}
      <div className="spCard__header">
        {speaker?.image ? (
          <div className="spCard__avatar spCard__avatar--image">
            <img
              src={`/storage/${speaker.image}`}
              alt={name}
              className="spCard__profileImg"
              onError={(e) => {
                e.currentTarget.style.display = "none";
                e.currentTarget.nextElementSibling.style.display = "flex";
              }}
            />
            <div className="spCard__initial fallback-initial">{initials}</div>
          </div>
        ) : (
          <div className="spCard__avatar">
            <div className="spCard__initial">{initials}</div>
          </div>
        )}

        <div className="spCard__meta">
          <div className="spCard__name">{name}</div>
          <div className="spCard__title">{speaker.title || "Speaker"}</div>

          {/* Country Section */}
          <div className="spCard__countryRow">
            {flagUrl && (
              <img
                className="spCard__flag"
                src={flagUrl}
                alt={countryName}
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
              />
            )}
            <span className="spCard__countryText">
              {countryName || "Country: —"}
            </span>
          </div>

          {/* Biography Section added below country */}
          <div className="spCard__bio">
            <p className="spCard__bioText">{shortBio}</p>
            {biography.length > 60 && (
              <button
                className="spCard__readMore"
                onClick={() => setShowBioModal(true)}
              >
                Read More
              </button>
            )}
          </div>
        </div>
      </div>

      {/* 2. Enhanced Modal (Complete speaker profile) */}
    {/* 2. Simple Modal (Sirf Complete Biography) */}
{showBioModal && (
  <div className="bio-modal-overlay">
    <button
      className="bio-modal-close"
      onClick={() => setShowBioModal(false)}
    >
      ×
    </button>
    <div className="bio-modal-content">
      <div className="bio-modal-header">
        <h3>{name}</h3>
      </div>
      <div className="bio-modal-body">
        <div className="complete-bio">
          {biography ? (
            <p>{biography}</p>
          ) : (
            <p>No biography available.</p>
          )}
        </div>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default SingleSpeakerV2;